import React from "react";
import { MDBCol } from "mdbreact";

class Start extends React.Component {
  render() {
    return (
      <div
        id="apppage"
        style={{ marginTop: "100px", marginLeft: "50px", marginRight: "50px" }}
      >
        <MDBCol>
          <p className="terms_title">
            TÉRMINOS Y CONDICIONES PARA USUARIOS TOVO
          </p>
          <p className="terms_section">1. OBJETO: RELACION CONTRACTURAL.-</p>
          <p className="terms_body">
            Las presentes Condiciones Generales de Uso regulan el acceso o uso
            que usted haga como persona en la aplicación informática TOVO (en
            adelante, la “Aplicación”) y del sitio web www.tovo.ec (en adelante,
            el “Sitio Web”), ya sea con su actual nombre o con cualquier otra
            denominación con la que se pueda figurar en el futuro, es una
            sociedad civil SA, con domicilio en la ciudad de Quito, que en
            adelante se denominara TOVO S.A. La Aplicación está dirigida
            exclusivamente a usuarios residentes en la República del Ecuador. Al
            acceder, registrarse y utilizar esta Aplicación y/o Sitio Web usted
            en adelante (“Usuario”) reconoce que ha leído y aceptado estas
            Condiciones Generales de Uso de nuestra plataforma electrónica y se
            compromete a cumplir con todos sus términos y condiciones, y acuerda
            vincularse jurídicamente por estas Condiciones, que establecen una
            relación contractual entre usted y TOVO. Si usted no acepta estas
            Condiciones, no podrá acceder o usar los Servicios. Estas
            Condiciones sustituyen expresamente los acuerdos o compromisos
            previos con usted. TOVO se reserva el derecho de poner fin de
            inmediato a estas Condiciones o cualquiera de los Servicios respecto
            de usted o, en general, dejar de ofrecer o denegar el acceso a los
            Servicios o cualquier parte de ellos, en cualquier momento en caso
            de que exista algún incumplimiento a las Condiciones. Asimismo, el
            Usuario reconoce y acepta que el acceso y uso de esta Aplicación y/o
            Sitio Web estará́ sujeto a las Condiciones Generales de Uso que se
            encuentren en vigor en el momento en que acceda a la misma. TOVO se
            reserva el derecho de modificar en cualquier momento las presentes
            Condiciones Generales de Uso, así́ como otras condiciones generales o
            particulares que resulten de aplicación. Las modificaciones serán
            efectivas después de la publicación por parte de TOVO de dichas
            Condiciones actualizadas en esta aplicación informática o sitio web
            www.tovo.ec. Su acceso o uso continuado de los Servicios después de
            dicha publicación constituye su consentimiento a vincularse por las
            Condiciones y sus modificaciones. Asimismo, TOVO se reserva el
            derecho de suspender, interrumpir o dejar de operar la Aplicación
            y/o el Sitio Web en cualquier momento.
          </p>
          <p className="terms_section">2. CONTENIDOS</p>
          <p className="terms_body">
            Los presentes términos y condiciones tienen por objeto regular el
            acceso y los términos de uso de la Plataforma. Se ruega leer
            atentamente estas condiciones. Entendiéndose y reconociendo que TOVO
            no es parte en ningún contrato, acuerdo o relación contractual, de
            ninguna clase, suscrito entre los Usuarios de su Plataforma. Usted
            reconoce que Tovo no presta servicios de transporte o de logística o
            funciona como una empresa de transportes y que dichos servicios de
            transporte o logística se prestan por terceros contratistas
            independientes, que no están empleados por TOVO ni por ninguna de
            sus afiliados. Los servicios se ponen a disposición solo para su uso
            personal, no comercial. A través de la Aplicación, TOVO facilita al
            Usuario un servicio de conexión tecnológica entre usuarios que
            prestan sus servicios de transporte terrestre, con usuarios que
            requieren servicios de transporte terrestre en la República del
            Ecuador manejarnos en el acceso de plataforma electrónica con
            diversos propósitos vinculados netamente a la tecnología que en
            adelante se denominara el “Servicio”. La Aplicación y/o Sitio Web,
            facilita al Usuario el acceso a diversos contenidos, información y
            datos proporcionados por TOVO en relación con el Servicio
            Tecnológico (en adelante, los “Contenidos”). TOVO se reserva el
            derecho a modificar en cualquier momento la presentación, la
            configuración, servicio y ubicación de la Aplicación y/o el Sitio
            Web, así́ como las correspondientes condiciones de acceso y uso. TOVO
            no garantiza que los contenidos y/o datos proporcionados a través de
            la Aplicación y/o Sitio Web serán en todo caso correctos, completos
            o actualizados.
          </p>
          <p className="terms_section">3. ACCESO Y USO</p>

          <p className="terms_body">
            La Plataforma solamente puede ser utilizada por personas mayores de
            18 años. Está estrictamente prohibido el registro en la plataforma
            por parte de un menor. Al acceder, utilizar o registrarse en la
            Plataforma, se confirma y garantiza que el Usuario es mayor de 18
            años. No obstante lo anterior, el acceso a determinados contenidos
            y/o participación en las promociones de TOVO puede estar limitado a
            mayores de edad o menores emancipados, según se indique en cada
            caso. Con carácter general, el Usuario podrá́ acceder a la Aplicación
            y/o el Sitio Web de forma libre y gratuita, dependiendo el uso y
            servicio tecnológico requerido. El Usuario reconoce y acepta que el
            acceso y uso de la Aplicación y/o Sitio Web tiene lugar libre y
            conscientemente, bajo su exclusiva responsabilidad, ya que para
            registrarse a la plataforma es necesario que haya leído y aceptado
            los términos, condiciones y la política de privacidad. TOVO no será́
            en ningún caso responsable del uso que el Usuario y/o terceros
            pudieran hacer de la Aplicación y/o Sitio Web ni de los daños y
            perjuicios que pudieran derivarse del mismo. El usuario al crear su
            Cuenta, independientemente del método seleccionado, se compromete a
            proporcionar información verídica y precisa, y a actualizar dicha
            información por medio de su perfil o enviando una notificación a
            TOVO, con el objetivo de garantizar su relevancia y precisión
            durante la duración total de tu relación con TOVO. El Usuario se
            compromete a hacer un uso adecuado y lícito de la Aplicación y/o
            Sitio Web de conformidad con la legislación aplicable, las presentes
            Condiciones Generales de Uso, la moral y buenas costumbres
            generalmente aceptadas y el orden público (revisar). El Usuario
            deberá́ abstenerse de (I) Hacer un uso no autorizado o fraudulento de
            la Aplicación y/o Sitio Web; (II) Acceder o intentar acceder a
            recursos restringidos de la Aplicación y/o Sitio Web; (III) Utilizar
            la Aplicación y/o Sitio Web con fines o efectos ilícitos, ilegales,
            contrarios a lo establecido en las presentes Condiciones Generales
            de Uso, a la buena fe y al orden público, lesivos de los derechos e
            intereses de terceros, o que de cualquier forma puedan dañar,
            inutilizar, sobrecargar o impedir la normal utilización o disfrute
            de la Aplicación y/o Sitio Web, como también utilizar la aplicación
            para hacer daño a otros usuarios del servicio tecnológico o
            terceros; (IV) Provocar daños en la Aplicación y/o Sitio Web o en
            los sistemas de sus proveedores o de terceros y/o cualquier
            alteración al sistema tecnológico brindado; (V) Introducir o
            difundir virus informáticos o cualesquiera otros sistemas físicos o
            lógicos que sean susceptibles de provocar daños en los sistemas de
            Tovo, de sus proveedores o de terceros, (VI) Intentar acceder,
            descargar, infringir, utilizar y/o manipular los datos de Tovo,
            terceros proveedores y otros usuarios; (VII) Reproducir o copiar,
            distribuir, permitir el acceso del público a través de cualquier
            modalidad de comunicación pública, transformar o modificar los
            Contenidos, a menos que se cuente con la autorización del titular de
            los correspondientes derechos o ello esté legalmente permitido o
            facultado; (VIII) Obtener o intentar obtener los contenidos
            empleando para ello medios o procedimientos distintos de los que,
            según los casos, se hayan puesto a su disposición a este efecto. El
            Usuario únicamente podrá́ acceder a la Aplicación a través de los
            medios autorizados. Es responsabilidad del Usuario asegurarse de que
            ha descargado la Aplicación correcta en su dispositivo. Tovo no será́
            responsable en caso de que el Usuario no disponga de un dispositivo
            compatible o haya descargado una versión de la Aplicación
            incompatible con su dispositivo; (IX) causar o lanzar cualquier
            programa o script con el objeto de extraer, indexar, analizar o de
            otro modo realizar prospección de datos de cualquier parte de los
            Servicios o sobrecargar o bloquear indebidamente la operación y/o
            funcionalidad de cualquier aspecto de los Servicios; y, (X)
            descompilar, realizar ingeniería inversa o desmontar los Servicios.
          </p>
          <p className="terms_section">4. VERIFICACIÓN</p>
          <p className="terms_section"></p>
          <p className="terms_body">
            TOVO podrá, con fines de transparencia, de mejora de la veracidad o
            de prevención o detección de fraude, establecer un sistema para
            verificar parte de la información proporcionada en el perfil del
            usuario. Se trata, fundamentalmente, de aquellos casos en los que
            introducen los números de teléfono o nos proporcionan un Documento
            de Identidad. TOVO no puede garantizar la veracidad, fiabilidad o
            validez de la información sujeta al procedimiento de verificación.
          </p>
          <p className="terms_body">
            Cualquier utilización de los Servicios, tanto en calidad de Pasajero
            como de Conductor, está relacionada con un nombre específico. La
            identidad del Conductor y del Pasajero debe corresponderse con la
            identidad comunicada por los mismos en TOVO que participan en el
            Trayecto.
          </p>
          <p className="terms_section">5. FUNCIONAMIENTO</p>
          <p className="terms_body">
            El Usuario se compromete a mantener la información en su Cuenta de
            forma exacta, completa y actualizada. Si no mantiene la información
            de Cuenta de forma exacta, completa y actualizada, incluso el tener
            un método de pago inválido o que haya vencido, podrá resultar en su
            imposibilidad para acceder y utilizar los Servicios o en la
            resolución por parte de TOVO de estas Condiciones aceptadas con
            usted. Usted es responsable de toda la actividad que ocurre en su
            Cuenta y se compromete a mantener en todo momento de forma segura y
            secreta el nombre de usuario y la contraseña de su Cuenta. A menos
            que TOVO permita otra cosa por escrito, usted solo puede poseer una
            Cuenta. Usted no podrá autorizar a terceros a utilizar su Cuenta,
            asimismo no podrá permitir a personas menores de 18 años que reciban
            servicios de transporte o soliciten transporte, a menos que aquellos
            sean acompañados por usted. No podrá ceder o transferir de otro modo
            su Cuenta a cualquier otra persona o entidad. Usted acuerda cumplir
            con todas las leyes aplicables al utilizar los Servicios y solo
            podrá utilizar los Servicios con fines legítimos (p. ej., no para el
            transporte de materiales ilegales o peligrosos). En el uso de los
            Servicios, no causará estorbos, molestias, incomodidades o daños a
            la propiedad, tanto al Tercero proveedor como a cualquier otra
            parte. En algunos casos, se le podrá requerir que facilite un
            documento de identidad u otro elemento de verificación de identidad
            para el acceso o uso de los Servicios, y usted acepta que se le
            podrá denegar el acceso o uso de los Servicios si se niega a
            facilitar el documento de identidad o el elemento de verificación de
            identidad. TOVO te anima a publicar tus comentarios y/o valoraciones
            sobre un Conductor con el cual hayas compartido un Trayecto o con
            quien se supone que hubieses debido compartir un Trayecto. El
            usuario reconoce y acepta que TOVO se reserva el derecho a no
            publicar o a eliminar cualquier comentario, pregunta, opinión o
            respuesta a los mismos si considera que su contenido incumple lo
            establecido en los presentes términos y condiciones. TOVO se reserva
            el derecho a suspender tu Cuenta o limitar su acceso a los Servicios
            en caso de que (i) hayas recibido al menos tres valoraciones
            negativas y (ii) las opiniones promedias que hayas recibido tenga
            una puntuación de 4 o inferior.
          </p>
          <p className="terms_section">
            6. CONDICIONES ADICIONALES PARA EL ACCESO Y USO
          </p>
          <p className="terms_body">
            El acceso a la Aplicación estará́ sujeto en todo caso al previo
            registro del Usuario, a través del despliegue de la aplicación. TOVO
            se reserva el derecho de aceptar o rechazar libremente la solicitud
            de registro por parte del Usuario. Los datos introducidos por el
            Usuario en el Formulario de Registro deberán ser exactos, actuales y
            veraces en todo momento. El acceso, convalidación y uso de la
            Aplicación o del área específica del Sitio Web será responsabilidad
            del usuario al rellenar el Formulario de Registro. El Usuario será́
            responsable en todo momento de la custodia de su acceso, asumiendo,
            en consecuencia, sobre los daños y perjuicios que pudieran derivarse
            de su uso indebido, así́ como de la cesión, revelación o extravío del
            mismo. En caso de cualquier otra circunstancia que suponga un riesgo
            de acceso y/o utilización por parte de terceros no autorizados, el
            Usuario lo comunicará inmediatamente a TOVO a fin de que éste
            proceda inmediatamente al bloqueo y sustitución de este. En todo
            caso, cualquiera de las operaciones realizadas antes de dicha
            comunicación se reputará efectuadas por el Usuario, quien será́
            responsable y pagará los gastos y/o daños que se deriven de
            cualquier acceso y/o uso no autorizado que se realice con
            anterioridad a
          </p>
          <p className="terms_body">
            Los Servicios y todos los derechos relativos a estos son y
            permanecerán de la propiedad de TOVO. Ninguna de estas Condiciones
            ni su uso de los Servicios le transfieren u otorgan ningún derecho
            como Usuario: (i) sobre o en relación con los Servicios; o bien (ii)
            a utilizar o mencionar en cualquier modo a los nombres de compañía,
            logotipos, nombres de producto y servicio, marcas comerciales o
            marcas de servicio de TOVO.
          </p>
          <p className="terms_section">7. ACEPTACIÓN</p>
          <p className="terms_body">
            El usuario conoce que el acceso o uso que haga como persona en la
            aplicación informática TOVO (en adelante, la “Aplicación”) y del
            sitio web www.tovo.ec (en adelante, el “Sitio Web”), y los términos
            y condiciones estipulados en este documento, son aceptados con la
            simple la trasmisión de mensajes de datos con la apertura (envío y
            recepción), autorizando a TOVO desmaterializarlos cuando estos deban
            instrumentarse físicamente por requerimiento de la Ley. El usuario
            conoce y acepta que al utilizar los Servicios y la Plataforma
            concierne exclusivamente para ponerse en contacto con el
            transportista que le brindará el servicio de traslado, con fines no
            comerciales y no empresariales. Tovo se reserva el derecho a
            suspender la cuenta del usuario en caso de que utilice un vehículo
            de alquiler con conductor u otro vehículo comercial, taxi o vehículo
            de empresa con el objetivo de generar un beneficio a través de la
            Plataforma. Usted acepta que se le podrá denegar el acceso o uso de
            los Servicios si se niega a facilitar el
          </p>
          <p className="terms_section">
            8. COMPROMISO DE TODAS LAS PERSONAS QUE VISITAN LA PLATAFORMA
          </p>
          <p className="terms_body">
            El Usuario reconoce ser el único responsable de respetar todas las
            leyes, normativas y obligaciones aplicables a la utilización la
            aplicación informática TOVO (en adelante, la “Aplicación”) y del
            sitio web www.tovo.ec (en adelante, el “Sitio Web”), además se
            compromete a: a) No utilizar la Plataforma con fines profesionales,
            comerciales o con ánimo de lucro; b) No enviar a TOVO (especialmente
            en el momento de crear o actualizar la Cuenta) información falsa,
            confusa, maliciosa o fraudulenta; c) No hablar ni comportarse , ni
            publicar ningún contenido en la Plataforma que pueda resultar
            difamatorio, injurioso, obsceno, pornográfico, vulgar, ofensivo,
            agresivo, improcedente, violento, amenazante, acosador, de
            naturaleza racista o xenófoba, que tenga connotaciones sexuales,
            incite a la violencia, discriminación u odio, o que fomente
            actividades o el uso de substancias ilegales o de forma más general
            que sea contrario a los objetivos de la Plataforma y que pueda
            infringir los derechos de TOVO o una tercera parte, o que pueda ser
            contrario a las buenas costumbres; d) No infringir los derechos y no
            dañar la imagen de TOVO, en especial en lo que respecta a sus
            derechos de propiedad intelectual; e) No abrir más de una Cuenta en
            la Plataforma y no abrir una Cuenta en nombre de un tercero; f) No
            aceptar ni realizar el pago fuera de la Plataforma; g) Cumplir con
            los presentes términos y condiciones y con la Política de
            privacidad. h) No ceder o transferir de otro modo su Cuenta a
            cualquier otra persona o entidad.
          </p>

          <p className="terms_section">8.1 COMPROMISO COMO PASAJERO</p>
          <p className="terms_body">
            Cuando el Usuario utiliza la Plataforma como Pasajero, se compromete
            a: a) Adoptar un comportamiento apropiado durante el Trayecto de
            modo que no interrumpa la concentración o la conducción del
            Conductor; b) RespetarelvehículodelConductorysulimpieza; c)
            EsperaralConductorenelpuntodeencuentroacordado; d) Presentar a TOVO,
            o a cualquier Conductor que lo solicite, su documento de identidad o
            cualquier otro documento que pruebe su identidad para el acceso o
            uso de los Servicios; e) No transportar durante un Trayecto ningún
            artículo, sustancia o animal que pueda distraer la concentración y
            conducción del Conductor, o cuya naturaleza, posesión o transporte
            sea ilegal; f) En el caso de un Trayecto transfronterizo, mantener y
            tener disponible para el Conductor y para cualquier autoridad que lo
            solicite, un documento válido que muestre su identidad y su derecho
            a cruzar la frontera; g)
            AsegurarsedequelosConductorespuedencontactarteenelnúmerodeteléfonoregistrado
            en su perfil, incluso en el punto de reunión. h) No causar estorbos,
            molestias, incomodidades o daños a la propiedad, tanto al tercero
            proveedor como a cualquier otra parte. i) Abstenerse de transportar
            sustancias prohibidas por la ley, de incumplir este acuerdo, el
            usuario será absolutamente responsable, sujeto a la ley..
          </p>

          <p className="terms_section">9. CONDICIONES DE PAGO Y FACTURACIÓN</p>
          <p className="terms_body">
            Las tarifas aplicables al Servicio serán cobradas por TOVO de forma
            automática, una vez finalizado el desplazamiento, a través de dinero
            en efectivo o transferencia bancaria que realizará directamente al
            conductor, o TOVO se reserva el derecho a solicitar la
            pre-autorización del cobro durante el trayecto donde TOVO solicite
            su pago que el Usuario hubiere aceptado. Las tarifas cobradas no
            serán reembolsables. Las tarifas y los gastos de cancelación y
            compensación, así́ como sus actualizaciones, están disponibles en
            todo momento en la Aplicación y/o Sitio Web y están sujetas a
            posibles modificaciones. Se recomienda al Usuario que acceda
            periódicamente a la Aplicación y/o el Sitio Web para conocer las
            tarifas aplicables en cada momento, como también método de pago. El
            usuario acepta que en los periodos de mayor demanda se cobre un
            costo adicional variable. Este costo adicional se encuentra incluido
            en el precio final. En el momento en que el usuario solicite el
            servicio a través de la Aplicación, podrá́ consultar una estimación
            de dicho costo junto con el precio estimado del trayecto, que se
            muestra siempre que se haya incluido el punto de destino. Asimismo,
            las condiciones y uso de descuento se detallan siempre dentro del
            medio utilizado para la comunicación del mismo. TOVO se reserva el
            derecho a restringir el uso y a recuperar el importe de las
            promociones, invitaciones y descuentos a aquellos Usuarios que hagan
            un uso inadecuado, ilícito o abusivo de los mismos. Está
            terminantemente prohibido que un Usuario cree diferentes cuentas
            TOVO o comparta un método de pago electrónico o regular con otros
            usuarios con el fin de beneficiarse indebidamente de descuentos e
            invitaciones, lo cual se considera un uso abusivo de las mismas. Las
            invitaciones y descuentos perderán su valor a los tres meses de su
            creación. Además, TOVO se reserva el derecho a anular o reducir el
            valor de los descuentos, invitaciones y promociones en cualquier
            momento. Por último, el valor de las invitaciones o descuentos podrá́
            estar limitado a ciertas categorías de vehículos. En particular, las
            invitaciones y descuentos no serán válidos para categorías de
            vehículos disponibles para atender a clientes corporativos. Con
            arreglo a lo dispuesto en la Política de Privacidad, los datos de la
            tarjeta de crédito facilitados u otros métodos de pago en el
            Formulario de Registro serán remitidos a la empresa proveedora de
            pagos y encargada de almacenar dichos datos del Usuario. El Usuario
            deberá́ acceder o podrá́ ser redirigido al sitio Web del proveedor de
            pagos a través del enlace facilitado al efecto en el Formulario de
            Registro. En todo caso se recomienda al Usuario consultar los
            términos y condiciones de uso y las políticas de privacidad de los
            sitios Web de terceros a los que accedan a través de enlaces
            incluidos en la Aplicación y/o Sitio Web. Por motivos de seguridad
            no está́ permitido utilizar un mismo método de pago en más de dos
            cuentas independientes. En caso de que se sobrepase este número la
            empresa puede proceder a bloquear el servicio a todas las cuentas
            hasta que se demuestre documentalmente la propiedad de las cuentas y
            del método de pago. Las facturas electrónicas estarán a disposición
            del Usuario de TOVO sin perjuicio de que puedan consultarlas a
            través de la Aplicación y/o Sitio Web y/o enviados por correo
            electrónico. A efectos puramente informativos, las facturas
            electrónicas podrán ser consultadas a través de la Aplicación y/o
            Sitio Web. El cobro será en efectivo, deposito en cuentas bancarias
            o plataforma electrónica aceptada por el Usuario. Los pagos por
            plataforma electrónica serán mediante la empresa dedicada a cobros
            por los medios mencionados. Al caso de utilizar plataforma
            electrónica de cobros, los datos proporcionados son de
            responsabilidad del Usuario, los datos de cuentas, tarjetas de
            crédito o débito, deben ser legítimamente del usuario, la plataforma
            electrónica que canalice los cobros como también TOVO, no tendrán
            responsabilidad alguna al existir fraude, en caso de existir el
            mismo deberá ser canalizado mediante la autoridad competente, todo
            dato compartido del Usuario se mantendrá estricto sigilo y resguardo
            de la información compartida tanto como la canalizadora de cobros
            electrónicos como la aplicación, se mantendrá protección de datos
            conforme a las leyes y disposiciones gubernamentales vigentes en el
            País. Políticas de cancelación y devolución: Para cancelar un
            trayecto ya cobrado por cualquiera de nuestros medios que ofrece
            TOVO, deberá hacerse una hora antes de iniciar el trayecto
            programado, luego de comunicar la cancelación la devolución del
            monto cobrado se realizará dentro de 10 días laborables previa
            cancelación, se deberá notificar a la aplicación para la logística
            de devolución de valores. Si se cancela el trayecto faltando una
            hora de inicio solo se reembolsará el 50% del valor cobrado. Si ya
            se inició el trayecto programado y se encuentra en el transcurso del
            mismo por ningún motivo se podrá reembolsar los montos acordados. La
            plataforma electrónica que canalizará los cobros únicamente se
            dedicará a la recaudación de tarifas y valores que la plataforma
            TOVO ofrezca y los usuarios acepten. El Usuario acepta la
            canalización de cobros con la plataforma electrónica que TOVO
            ofrece, queda claro que dicho cobro no lo hará directamente TOVO,
            sino una compañía dedicada al manejo electrónico de cobros, ambas
            sociedades garantizarán y precautelarían la información y estarán
            regidas bajo la normativa, fiscal y comercial del país. Los
            impuestos generados serán debidamente notificados, y cobrados. Los
            datos para facturación electrónica serán emitidos a nombre del
            titular de la cuenta.
          </p>

          <p className="terms_section">
            10. DERECHOS DE PROPIEDAD INTELECTUAL E INDUSTRIAL
          </p>
          <p className="terms_body">
            El Usuario reconoce y acepta que todos los derechos de propiedad
            intelectual e industrial sobre los contenidos y/o cualquiera de los
            otros elementos insertados en la Aplicación y/o Sitio Web
            (incluyendo, sin limitación, marcas, logotipos, nombres comerciales,
            textos, imágenes, gráficos, diseños, sonidos, bases de datos,
            software, diagramas de flujo, presentación, audio y video),
            pertenecen a Tovo. Tovo autoriza al Usuario a utilizar, visualizar,
            imprimir, descargar y almacenar los contenidos y/o los elementos
            insertados en la Aplicación y/o Sitio Web exclusivamente para su uso
            personal, privado y no lucrativo, no se podrá utilizar la imagen de
            Tovo de mala fe o buscar un fin que afecte a la imagen y prestigio
            de la plataforma tecnológica, absteniéndose de realizar sobre los
            mismos cualquier acto de descompilación, ingeniería inversa,
            modificación, divulgación o suministro. Cualquier otro uso o
            explotación de cualesquiera contenidos y/u otros elementos
            insertados en la aplicación y/o Sitio Web distinto de los aquí́
            expresamente previstos estará́ sujeto a la autorización previa de
            Tovo.
          </p>

          <p className="terms_section">11. PROTECCIÓN DE DATOS</p>
          <p className="terms_body">
            Los datos personales (en lo sucesivo, los Datos) que Usted
            proporciona por medio del Formulario de Registro, o acceso a
            ubicación, se integrarán en un fichero de datos personales del que
            es responsable Tovo, cuya dirección figura en el encabezamiento del
            presente documento. Para más
          </p>

          <p className="terms_section">
            12. EXCLUSIÓN DE GARANTÍAS Y RESPONSABILIDAD
          </p>
          <p className="terms_body">
            Tovo no garantiza la disponibilidad y continuidad del funcionamiento
            de la aplicación y/o Sitio Web. En consecuencia, Tovo no será́ en
            ningún caso responsable por cualesquiera daños y perjuicios que
            puedan derivarse de: (1) La falta de disponibilidad o accesibilidad
            a la aplicación y/o Sitio Web; (2) La interrupción en el
            funcionamiento de la aplicación y/o Sitio Web o fallos informáticos,
            averías telefónicas, desconexiones, retrasos o bloqueos causados por
            deficiencias o sobrecargas en las líneas telefónicas, centros de
            datos, en el sistema de Internet o en otros sistemas electrónicos,
            producidos en el curso de su funcionamiento; y (3) Otros daños que
            puedan ser causados por terceros mediante intromisiones no
            autorizadas ajenas al control de Tovo. Tovo no garantiza la ausencia
            de virus ni de otros elementos en la aplicación y/o Sitio Web
            introducidos por terceros ajenos a Tovo que puedan producir
            alteraciones en los sistemas físicos o lógicos del Usuario o en los
            documentos electrónicos y ficheros almacenados en sus sistemas. En
            consecuencia, Tovo no será́ en ningún caso responsable de cualquiera
            de los daños y perjuicios de toda naturaleza que pudieran derivarse
            de la presencia de virus u otros elementos que puedan producir
            alteraciones en los sistemas físicos o lógicos, documentos
            electrónicos o ficheros del Usuario. Tovo adopta diversas medidas de
            protección para proteger la aplicación y/o Sitio Web y los
            contenidos contra ataques informáticos de terceros. No obstante,
            Tovo no garantiza que terceros no autorizados no puedan conocer las
            condiciones, características y circunstancias en las cuales el
            Usuario accede a la aplicación y/o Sitio Web. En consecuencia, Tovo
            no será́ en ningún caso responsable de los daños y perjuicios que
            pudieran derivarse de dicho acceso no autorizado. Con la suscripción
            de las presentes Condiciones Generales de Uso, Usted declara que
            mantendrá́ indemne frente a cualquier reclamación a Tovo, su sociedad
            matriz, directores, socios, empleados, abogados y agentes derivadas
            del: (a) Incumplimiento por parte del Usuario de cualquier
            disposición contenida las presentes Condiciones Generales de Uso o
            de cualquier ley o regulación aplicable a las mismas, (b)
            Incumplimiento o violación de los derechos de terceros incluyendo, a
            título meramente enunciativo, los terceros transportistas, otros
            conductores y peatones; y (c) Incumplimiento del uso permitido de la
            aplicación y/o Sitio Web. La prestación final del servicio de
            transporte quedará a discreción del tercer transportista. En caso de
            que, una vez procesada la solicitud por parte del Usuario, el tercer
            transportista (usuario de plataforma) rechace efectuar el
            desplazamiento por causa del destino o por cualquier otra causa, el
            Usuario podrá́ ponerse en contacto con Tovo para que, en la medida de
            lo posible, ésta proporcione al Usuario un vehículo de sustitución
          </p>

          <p className="terms_section">13. RENUNCIA.</p>
          <p className="terms_body">
            Los servicios se proporcionan “tal cual” y “como disponibles”. Tovo
            renuncia a toda declaración y garantía, expresa, implícita o
            estatutaria, no expresamente establecida en estas condiciones,
            incluidas las garantías implícitas de comerciabilidad, idoneidad
            para un fin particular y no violación. además, tovo no hace
            declaración ni presta garantía alguna relativa a la fiabilidad,
            puntualidad, calidad, idoneidad o disponibilidad de los servicios o
            cualquiera de los servicios o bienes solicitados a través del uso de
            los servicios, o que los servicios no serán interrumpidos o estarán
            libres de errores. Tovo no garantiza la calidad, idoneidad,
            seguridad o habilidad de los terceros proveedores. Usted acuerda que
            todo riesgo derivado de su uso de los servicios y cualquier servicio
            o bien solicitado en relación con aquellos será únicamente suyo, en
            la máxima medida permitida por la ley aplicable.
          </p>

          <p className="terms_section">14. LIMITACIÓN DE RESPONSABILIDAD.</p>
          <p className="terms_body">
            Tovo no será responsable de daños indirectos, incidentales,
            especiales, ejemplares, punitivos o emergentes, incluidos el lucro
            cesante, la pérdida de datos, la lesión personal o el daño a la
            propiedad, ni de perjuicios relativos, o en relación con, o de otro
            modo derivados de cualquier uso de los servicios, incluso aunque
            tovo haya sido advertido de la posibilidad de dichos daños. Tovo no
            será responsable de cualquier daño, responsabilidad o pérdida que
            deriven de: (1) su uso o dependencia de los servicios o su
            incapacidad para acceder o utilizar los servicios; o (2) cualquier
            transacción o relación entre usted y cualquier tercero proveedor,
            aunque tovo hubiera sido advertido de la posibilidad de dichos
            daños. Tovo no será responsable del retraso o de la falta de
            ejecución resultante de causas que vayan más allá del control
            razonable de tovo. Usted reconoce que los terceros proveedores de
            transporte que presten servicios de transporte solicitados a través
            de algunas marcas de pedidos podrán ofrecer servicios de coche
            compartido o entre pares (peer-to- peer) y puede que no dispongan de
            la licencia o del permiso profesional. En ningún caso la
            responsabilidad total de tovo hacia usted en relación con los
            servicios por todos los daños. Usted podrá utilizar los servicios de
            tovo para solicitar y planificar servicios de transporte, bienes o
            logísticos con terceros proveedores, pero acepta que tovo no tiene
            responsabilidad alguna hacia usted en relación con cualquier
            servicio de transporte, bienes o logístico prestado a usted por
            terceros proveedores que no sea como se ha establecido expresamente
            en estas condiciones. Las limitaciones y la renuncia en este acuerdo
            no pretenden limitar la responsabilidad o alterar sus derechos como
            consumidor que no puedan excluirse según la ley aplicable.
          </p>

          <p className="terms_section">15. COMUNICACIONES</p>
          <p className="terms_body">
            TOVO podrá́ realizar las notificaciones oportunas a través de una
            notificación general en la aplicación, a través de la dirección de
            correo electrónico facilitada por el Usuario en el Formulario de
            Registro o mediante correo ordinario a la dirección facilitada por
            el Usuario en el Formulario de Registro. El Usuario podrá́ notificar
            a TOVO Mobility mediante el envío de un correo electrónico que tovo
            proporcionara oportunamente.
          </p>

          <p className="terms_section">16. CESIÓN</p>
          <p className="terms_body">
            El Usuario no podrá́ ceder sus derechos y obligaciones de las
            presentes Condiciones Generales de Uso sin el previo consentimiento
            escrito de TOVO. transferir estas Condiciones, en todo o en parte, a
            cualquier entidad comprendida a cualquier Usted da su aprobación a
            TOVO para ceder o persona o entidad que le suceda en el ejercicio de
            su negocio por cualquier título. No existe entre Usted, TOVO o
            cualquier Tercer proveedor una empresa conjunta o relación de
            socios, empleo o agencia como resultado del contrato entre usted y
            TOVO o del uso de los Servicios.
          </p>

          <p className="terms_section">17. LEY APLICABLE Y JURISDICCIÓN</p>
          <p className="terms_body">
            Las presentes Condiciones Generales de Uso, así́ como la relación
            entre TOVO y el Usuario, se regirán e interpretaran con arreglo la
            ley ecuatoriana. Las partes acuerdan someterse a la jurisdicción
            exclusiva de los juzgados y tribunales del lugar de residencia de
            TOVO para la resolución de cualquier controversia en relación con
            las presentes Condiciones Generales de Uso o la relación entre las
            mismas, y/o organismos de mediación y arbitraje en cualquier lugar
            que fije TOVO.
          </p>

          <p className="terms_section">
            18. CONDICIONES DE USO DEL SERVICIO DE TRANSPORTE
          </p>
          <p className="terms_body">
            Cualquier daño y/o perjuicio que un usuario ocasione a los vehículos
            y/o a los conductores será́ asumido por el propio Usuario, y también
            las horas en que dicho vehículo ha estado fuera de servicio Usted
            acepta expresamente y otorga su consentimiento para que TOVO realice
            el cargo a su cuenta 19. DISPOSICIONES GENERALES por los referidos
            daños y/o perjuicios. En este supuesto, pago con el que paga
            usualmente el servicio, enviándole el comprobante de pago
            correspondiente por la reparación, conteniendo pero no limitándose a
            roturas, manchas, rayones, quemaduras y cualquier otro similar que
            dañe o perjudique el interior o exterior del vehículo, así́ como la
            integridad física del conductor, y también por las horas en el
            vehículo afectado ha estado fuera de servicio por los referidos
            daños y/o perjuicios generados por el usuario o sus pasajeros
            invitados. Asimismo, solicitamos a los usuarios se sirvan cuidar,
            revisar y recoger sus pertenencias terminado el trayecto, a efectos
            de evitar pérdidas o extravíos, de los cuales no podemos
            responsabilizarnos una vez el importe correspondiente al medio de
            terminado el viaje.
          </p>

          <p className="terms_section">19. DISPOSICIONES GENERALES</p>
          <p className="terms_body">
            Si cualquier disposición de estas Condiciones se considerara ilegal,
            nula o inexigible, ya sea en su totalidad o en parte, de conformidad
            con la legislación ecuatoriana, dicha disposición o parte de esta se
            considerará que no forma parte de estas Condiciones, aunque la
            legalidad, validez y exigibilidad del resto de las disposiciones de
            estas Condiciones no se verá afectada. En ese caso, las partes
            deberán reemplazar dicha disposición ilegal, nula o inexigible, en
            todo o en parte por una disposición legal, válida y exigible que
            tenga, en la medida de lo posible, un efecto similar al que tenía la
            disposición ilegal, nula o inexigible, dados los contenidos y el
            propósito de estas Condiciones. Estas Condiciones constituyen el
            contrato íntegro y el entendimiento entre las partes en relación con
            el objeto y sustituye y reemplaza a todos los contratos o acuerdos
            anteriores o contemporáneos en relación con dicho objeto.
          </p>

          <p className="terms_section">
            20.- CONDICIONES DE TRANSPORTE DE ENCOMIENDAS
          </p>
          <p className="terms_body">
            Por la seguridad de su envío, TOVO APP, NO se responsabiliza por el
            contenido interno de lo enviado así como de la pérdida, robo,
            asalto, o caso fortuito; de igual forma no será responsable por los
            bienes o valores que no hayan sido declarados previo a su envío. En
            este caso se indemnizará al cliente con el costo del envío, y en
            caso de ser valores declarados se indemnizará al cliente con el 100%
            de su factura. Las encomiendas sujetas a descomposición (perecibles)
            deberán ser retiradas en el plazo máximo de 48 horas, transcurrido
            este tiempo se procederá a dar de baja o a su vez la destrucción,
            sin responsabilidad alguna de TOVO APP, previa suscripción del acta
            correspondiente. No nos responsabilizamos por envíos de: dinero,
            cheques, joyas, documentos u objetos de valor en el interior de
            sobres o paquetes que no hayan sido declarados su valor. Por
            homónimos declare los nombres completos del destinatario y este a su
            vez está obligado a presentar su documento de identidad ORIGINAL
            para el retiro de su encomienda. No transportamos: armas, materiales
            explosivos, inflamables, sustancias estupefacientes y psicotrópicas
            u otras mercancías peligrosas y no nos responsabilizamos por
            mercancías dolosas, vicios ocultos en el envío y serán confiscadas
            para la investigación correspondiente, y se sujetarán las personas
            que actúen de manera maliciosa y de mala fe, que traten de
            perjudicar a TOVO APP, y a la persona que de buena fe está llevando
            la encomienda, a las disposiciones del Cogido Orgánico Integral
            Penal, salvando toda responsabilidad a TOVO y al propietario del
            transporte y sujeto a investigación el usuario que haya actuado de
            mala fe y haya procedido con acciones violentas, ocultas o
            temerarias, y todo acto y acciones contrarias a la ley del Ecuador.
          </p>
        </MDBCol>
      </div>
    );
  }
}

export default Start;
